<template>
    <v-container grid-list-lg>
        <v-layout row wrap style="padding-bottom:20px"> 
               <v-loading class="loading" v-model="loading" v-if="loading">
    
                    <v-progress-circular persistent
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                    ></v-progress-circular>
            
                </v-loading>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>Enquetes</v-toolbar-title>
                    <v-btn v-if="perfil == 2 || perfil == 3" flat to="/criar-enquete" outline color="white"  style="position:absolute; right:20px; top:7px">Novo</v-btn>
                </v-toolbar>

                <!--v-flex v-for="i in 10" :key="`4${i}`" xs12 sm8 md4-->
                <!--v-flex v-for="(fotografo, idx) in 10" :key="idx" xs12 sm8 md4-->
                <v-flex v-for="(item, index) in items" xs12 sm6 md4 row style="margin-bottom:10px; padding:0px">
                    
                    <v-card>
                        <img v-if="item.img != 'null'" :src="item.img" class="imagem" />
                        <v-card-text>
                            <v-btn class="deletar" v-if="perfil == 2 || perfil == 3" flat color="orange" flat="flat" @click="deletarItem(item.slug)"><img :src="lixeira" class="lixeira" /> </v-btn>
                            
                                <!--div class="imagem"  style="background-image: url('http://www.closebecoming.co.uk/images/category_10/Honey%20%20B%20Women%20Black%20Self%20Design%20Top%20Beautiful%20BLOVOT.jpg');" ></div-->
                                <div style="width:100%" class="body-content">
                                    
                                    <h3 class="headline mb-0" :title="item.texto">{{item.pergunta}}</h3> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                    <div>Data de inicio: {{item.dataInicio}}</div>
                                    <div>Data final: {{item.dataFinal}}</div><br />
                                    <div style="float:left; width:100%">
                                        <div class="etiqueta nao-iniciado" v-if="item.dateStartSemHifen > dataAtual">Não iniciado</div>
                                        <div class="etiqueta finalizado" v-if="item.dateEndSemHifen < dataAtual">Finalizado</div>
                                        <div class="etiqueta em-andamento" v-if="item.dateStartSemHifen < dataAtual && item.dateEndSemHifen > dataAtual">Em andamento</div>
                                    </div><br /><br />
                                    
                                </div>
                            
                            <v-card-actions>
                                <!-- <v-btn v-if="perfil == 2 || perfil == 3" class="editar" flat color="orange" flat="flat" @click="editarItem(item.slug)">Editar</v-btn> -->
                                <div class="confirmacoes" :data-slug-votos="item.slug" :data-docid-votos="item.docID" @click="votosPessoas(item.slug, item.docID, item.pergunta)"><b>Quantidade de votos(<span>0</span>)</b></div><br />
                                <v-btn :data-slug-votos="item.slug" :data-docid-votos="item.docID" class="release confirmacao" flat color="orange" flat="flat" @click="resultado(item.slug, item.docID, item.pergunta)">Resultado</v-btn>
                            </v-card-actions>
                            
                        </v-card-text>
                    
                    </v-card>
                </v-flex>

        </v-layout>
        <v-dialog v-model="dialogVotos" max-width="100%" style="margin:5px !important" id="votos">
            <v-card>
                <v-card-title class="headline">Votação</v-card-title>
                <v-card-text>
                    <b>Pergunta:</b> {{perguntaResultado}}<br />
                    <b>Total de votos: {{quantidadeVotos}}</b><br />
                    
                </v-card-text>
                <div id="chart">
                    <!-- <apexchart type=pie width=380 :options="chartOptions" :series="series" /> -->
                    <apexchart type=pie width=100% :options="chartOptions" :series="series" />
                </div>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <!-- <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn> -->
                    <v-btn color="green darken-1" flat @click="dialogVotos = false">Fechar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDeleteConfirm" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Deletar enquete?</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat @click="dialogDeleteConfirm = false">Não</v-btn>
                <v-btn color="green darken-1" flat @click="deletarItemConfirm">Sim</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Enquete deletada com sucesso!</v-card-title>
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-card-actions>
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogVotosPessoas" max-width="100%">
            
            <v-card>
                <a class="closeModal" @click="dialogVotosPessoas = false">x</a>
                <v-card-title class="headline">Votos({{quantidadeVotos}})</v-card-title><br />
                <!--v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text-->
                <v-flex v-for="(item, index) in itemsVotosPessoas">
                    <div class="itens-container">
                                    <div class="img" v-bind:style="{ 'background-image': 'url(' + item.img + ')' }" ></div>
                                    <div class="body-content">
                                        
                                        <b :title="item.nome">{{item.nome}}</b> <!-- {{ parentMessage }} - {{ index }} - {{ item.message }} -->
                                        
                                    </div>
                                
                                <!--v-card-actions>
                                    <div class="instagram" style="height:20px;"><a @click="diarioFiltradoPorAluno(item.slugAluno)">Diário</a></div>
                                    <v-btn class="editar" flat color="orange" flat="flat" @click="chegou(item.slugAluno)">Chegou</v-btn>
                                    <v-btn class="release" flat color="orange" flat="flat" @click="saiu(item.slugAluno)">Saiu</v-btn>
                                    
                                </v-card-actions-->
                        </div>
                    </v-flex>
                <v-card-actions>
                    
                <v-spacer></v-spacer>
                <!--v-btn color="green darken-1" flat @click="dialog = false">Disagree</v-btn-->
                <v-btn color="green darken-1" flat @click="dialogVotosPessoas = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>

import Vue from 'vue'
import db from './firebaseInit';
import firebase from 'firebase';

import lixeira from '../assets/ic-lixeira.png';

import { userProperties, usersData } from '@/global.js';

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

export default {
    name: 'Enquete-Listagem',
    components: {
        apexchart: VueApexCharts
    },
    data () {
        return {
            slug : '',
            lixeira: lixeira,
            
            dataAtual: null,
            dialogDeleteConfirm: false,
            dialogVotos: false,
            dialog: false,
            loading: false,
            perfil: userProperties.perfil,
            modalMessage: 'Enquete excluída com sucesso!',
            items: [],
            slugClicado: null,
            itemsVotosPessoas: [],
            quantidadeVotos: 0,
            dialogVotosPessoas: false,
            perguntaResultado: null,
            //apexchart
            series: [44, 55, 13, 43, 22],
            colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
            chartOptions: {
                labels: ['São Paulo', 'Avenida Paulista', 'Rua Clovis Bevilaqua, 360', 'Brasil', 'Texto grande para teste do resultado da enquete'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        // chart: {
                        //     width: 300
                        // },
                        legend: {
                            position: 'bottom'
                            
                        }
                    }
                }]
            }
        }
    },
    methods: {
        carregaDados() {
            this.fnDataAtual();

            // ordernar exibicao - numerica
            function ordenarPorTimestamp(a, b){
                //return a.dataNumero - b.dataNumero; // crescente
                return b.ordenacao - a.ordenacao; // decrescente
            }

            this.items = []
            this.loading = true
            let obj = []
            
            db.collection("enquete")
            .where("escolaID", "==", userProperties.escolaID)
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    this.loading = false;
                    alert("Nenhuma pesquisa foi criada.");
                }
                else{
                    querySnapshot.forEach(doc => {
                    
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()

                        function getSubCollection(){
                            // Build doc ref from doc.id
                            var quantidadeVotos = null;
                            var statusConfirmacao = false
                            db.collection("enquete").doc(doc.id).collection("votos")
                            .get()
                            .then((querySnapshot) => {
                                quantidadeVotos = querySnapshot.size;
                                querySnapshot.forEach(doc => {
                                    // doc.data() is never undefined for query doc snapshots
                                    console.log(doc.id, " => ", doc.data());                    
                                    let customObjConfirmacao = doc.data();

                                    // seta a quantidade de confirmacoes
                                    $( "div[data-slug-votos='"+customObj.slug+"']" ).find("b span").text(quantidadeVotos);
                                })
                            })
                        }

                        
                            // If anything goes wrong while getting the download URL, log the error,
                            this.items.push({"pergunta": customObj.pergunta, "descricao": customObj.descricao, "push": customObj.push, "preview": customObj.preview, "ordenacao":customObj.dateStart.replace(/-/g, ''), "dateStart": customObj.dateStart, "dateEnd": customObj.dateEnd, "dateStartSemHifen": customObj.dateStart.replace(/-/g, ''), "dateEndSemHifen": customObj.dateEnd.replace(/-/g, ''), "exibicaoName": customObj.exibicaoName, "slug": customObj.slug, "docID": doc.id, "slugAutor": customObj.slugAutor, "dataInicio": customObj.dateStart.split("-")[2] + "/" + customObj.dateStart.split("-")[1] + "/" + customObj.dateStart.split("-")[0], "dataFinal": customObj.dateEnd.split("-")[2] + "/" + customObj.dateEnd.split("-")[1] + "/" + customObj.dateEnd.split("-")[0]});
                            this.slug = customObj.slug;
                            this.items.sort(ordenarPorTimestamp)
                            getSubCollection();
                        
                            this.loading = false
                        
                    });
                }
                
            });
            console.log(this.items);

        },
        fnDataAtual(){
            // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                // var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                // var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                // var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                // //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                this.dataAtual = year + month + day;
        },
        editarItem(slug){
            this.$router.push(`/Editar-Enquete/?slug=`+slug)

        },
        displayItem(slug){
            this.$router.push(`/Display-Enquete/?slug=`+slug)

        },
        deletarItem(slug){
            this.slug = slug;
            this.dialogDeleteConfirm = true;
        },
        deletarItemConfirm(){
            var slug = this.slug;
            this.loading = true
            db.collection("enquete").where("slug", "==", slug)
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach((doc) => {
                    doc.ref.delete().then(() => {
                    this.dialog = true
                    console.log("Document successfully deleted!");
                    }).catch(function(error) {
                    console.error("Error removing document: ", error);
                    });
                });
                this.loading = false
                this.dialogDeleteConfirm = false;
                this.carregaDados();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
                this.loading = false;
                this.dialogDeleteConfirm = false;
                alert("Error while trying to delete, please try again.");
            });
        },
        generateUUID () {
          let d = new Date().getTime()
          let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = (d + Math.random() * 16) % 16 | 0
            d = Math.floor(d / 16)
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
          })
          return uuid
        },
        closeModal() {
            this.dialog = false      
            this.$router.push(`/`)
            this.$forceUpdate()
            Vue.delete(state.fixture, i)
        },
        resultado(slug, docID, pergunta){
            
            this.perguntaResultado = pergunta;

            var votosRealizados = [];
            db.collection("enquete").doc(docID).collection("votos")
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    alert("Essa enquete ainda não possui votos.")
                    this.loading = false;
                    this.dialogVotos = false;
                }
                else{
                    this.dialogVotos = true;
                    querySnapshot.forEach(doc => {
                        this.quantidadeVotos = querySnapshot.size;
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()
                        votosRealizados.push(customObj)

                        this.loading = false
                        
                    });
                    
                    var respostas = []
                    votosRealizados.forEach(function(item, index) {
                        respostas.push(item.resposta)
                    })

                    // Remove itens repetidos do array
                    var respostasUnicas = [];

                    respostasUnicas = respostas.filter(function (a) {
                        return !this[JSON.stringify(a)] && (this[JSON.stringify(a)] = true);
                    }, Object.create(null))

                    this.chartOptions = {
                      labels: respostasUnicas
                    };

                    var valor = 0;
                    var valoresRespostas = []
                    respostasUnicas.forEach(function(item, index) {
                        respostas.forEach(function(item2, index2) {
                            if(item == item2){
                                valor = valor + 1;
                            }
                        })
                        valoresRespostas.push(valor);
                        valor = 0
                    })
                    this.series = valoresRespostas
                    

                    
                    
                

                    // var votosRealizadosPropriedades = []; // objeto com as propriedades dos usuarios que já votaram
                    // votosRealizados.forEach(function(item, index) {
                    //     usersData.usuarios.forEach(function(item2, index2) {
                    //         if (item == item2.slug) {
                    //             var storageRef = firebase.storage().ref();
                    //             var tangRef = storageRef.child('profile/'+item2.slug + "." + item2.extensao);

                    //             // First we sign in the user anonymously
                    //             //firebase.auth().signInAnonymously().then((result) => {
                    //             // Once the sign in completed, we get the download URL of the image
                                
                    //             tangRef.getDownloadURL().then(urlImgFB =>                             {
                    //             // Once we have the download URL, we set it to our img element
                    //                 votosRealizadosPropriedades.push({"img":urlImgFB, "nome": item2.nome});

                    //             }).catch(function(error) {
                    //                 // If anything goes wrong while getting the download URL, log the error
                    //                 console.log(error);
                    //             });
                                
                    //         }
                    //     });
                    // });
                    // this.itemsVotosPessoas = votosRealizadosPropriedades;
                    
                }
            });
            
        },
        votosPessoas(slug, docID){
            this.itemsVotosPessoas = []
            this.quantidadeVotos = 0;
            
            this.loading = true;
            var votosRealizados = [];
            db.collection("enquete").doc(docID).collection("votos")
            .get()
            .then((querySnapshot) => {
                if(querySnapshot.size == 0){
                    alert("Essa enquete ainda não possui votos.")
                    this.loading = false;
                }
                else{
                    this.dialogVotosPessoas = true;
                    querySnapshot.forEach(doc => {
                        this.quantidadeVotos = querySnapshot.size;
                        // doc.data() is never undefined for query doc snapshots
                        //console.log(doc.id, " => ", doc.data());                    
                        let customObj = doc.data()
                        votosRealizados.push(customObj.slugAutor)

                        this.loading = false
                        
                    });
                    var votosRealizadosPropriedades = []; // objeto com as propriedades dos usuarios que já votaram
                    votosRealizados.forEach(function(item, index) {
                        usersData.usuarios.forEach(function(item2, index2) {
                            if (item == item2.slug) {
                                var storageRef = firebase.storage().ref();
                                var tangRef = storageRef.child('profile/'+item2.slug + "." + item2.extensao);

                                // First we sign in the user anonymously
                                //firebase.auth().signInAnonymously().then((result) => {
                                // Once the sign in completed, we get the download URL of the image
                                
                                tangRef.getDownloadURL().then(urlImgFB =>                             {
                                // Once we have the download URL, we set it to our img element
                                    votosRealizadosPropriedades.push({"img":urlImgFB, "nome": item2.nome});

                                }).catch(function(error) {
                                    // If anything goes wrong while getting the download URL, log the error
                                    console.log(error);
                                });
                                
                            }
                        });
                    });
                    this.itemsVotosPessoas = votosRealizadosPropriedades;
                    
                }
                
            });
        }
    },
    created() {
        this.carregaDados();
    }
};



</script>

<style scoped>
    .v-card__actions{
        padding-left: 0 !important;
    }

    .loading{
        position: fixed;
        top:20%;
        left:41%;
        z-index: 2;
    }

    .deletar{
        position: absolute;
        min-width: auto;
        height: auto;
        padding: 1px 6px !important;
        right: 0;
        top: 0;
    }

    .release{
        background-color:beige;
        position:xabsolute;
        right: 12px;
    }

    .editar{
        background-color:beige;
        position:absolute;
        right: 12px;
    }

    .imagem{
        width: 100%;
        height: auto;
    }

    .confirmado{
        background-color: #4CAF50 !important;
        border-color: #4CAF50 !important;
        color: #fff !important;
    }

    .img{
        width: 50px;
        height: 50px;
        margin-right: 12px;
        border:beige solid 1px;
        border-radius: 50%;
        background-position: center top;
        background-size: 100% auto;
        position: relative;
        top:-6px;
        float: left;
        margin-left:12px;
    }
    
    .itens-container{
        float: left;
        width: 100%;
        margin-bottom: 9px;
    }

    .itens-container .body-content{
        margin-top: 5px;
    }
    
    .closeModal{
        float: right;
        color:#000;
        margin: 5px 14px;
    }
    .v-dialog--active .v-card__actions{
        height: 50px;
    }

    .confirmacao{
        position: absolute;
        right: 12px;
    }

    #votos{
        max-width: 100% !important;
        margin: 5px !important;
    }

    .etiqueta{
        color: #fff;
        padding: 3px 10px;
        float: left;
    }

    .nao-iniciado{
        background: orange;
    }

    .finalizado{
        background: red;
    }

    .em-andamento{
        background: green;
    }

    .lixeira{
        margin-top: 5px;
    }
    
</style>
